import { WallTypeTypes } from "@iko-design-center/shared";
import React from "react";
// import { InfoList } from "../../common/InfoList";
import { Spacer } from "../../common/Spacer";
import { H1, P } from "../../common/Typography";
import { Grid } from "../Grid";
import { useWallType } from "./wallType.hooks";
import { Sidebar } from "../Sidebar";
import { getWallTypeTranslations } from "./translations";
import { Intro } from "../../viewer/DesignCenter";
import { isMobile } from "../../../services/helpers.service";
import { useTabs } from "../../navigation/tabs.hook";
import { IconTile } from "../IconTile";
import { ConcreteIcon, CrossWoodIcon, HollowStoneIcon, LimeSandIcon } from "../../common/MaterialIcons";

export const WallType = () => {
  const {
    t,
    wallTypeType,
    setWallTypeType,
    nextButtonDisabled,
    handleNextButtonClick,
  } = useWallType();

  const { currentStep, tabs } = useTabs();
  const totalSteps = tabs[tabs.length - 1].step

  return (
    <Sidebar
      handleNextButtonClick={handleNextButtonClick}
      nextButtonText={`${t("cavityWall.wallType.nextButton")} (${currentStep + 1}/${totalSteps})`}
      nextButtonDisabled={nextButtonDisabled}
    >
      <Intro>
        <H1>{t("cavityWall.wallType.title")}</H1>
        <Spacer heightPx={12} />
        <P lineHeightPx={22}>{t("cavityWall.wallType.subtitle")}</P>
        {!isMobile() && <Spacer heightPx={32} />}
      </Intro>
      <Grid rows={2} gaps={true} className={"tiles-grid"}>
        <IconTile
          selected={wallTypeType === WallTypeTypes.CONCRETE_WALL}
          text={getWallTypeTranslations(t, WallTypeTypes.CONCRETE_WALL)}
          onClick={() => setWallTypeType(WallTypeTypes.CONCRETE_WALL)}>
          <ConcreteIcon />
        </IconTile>
        <IconTile
          selected={wallTypeType === WallTypeTypes.LIME_SAND_WALL}
          text={getWallTypeTranslations(t, WallTypeTypes.LIME_SAND_WALL)}
          onClick={() => setWallTypeType(WallTypeTypes.LIME_SAND_WALL)}>
          <LimeSandIcon />
        </IconTile>
        <IconTile
          selected={wallTypeType === WallTypeTypes.HOLLOW_STONE_WALL}
          text={getWallTypeTranslations(t, WallTypeTypes.HOLLOW_STONE_WALL)}
          onClick={() => setWallTypeType(WallTypeTypes.HOLLOW_STONE_WALL)}>
          <HollowStoneIcon />
        </IconTile>
        <IconTile
          selected={wallTypeType === WallTypeTypes.CROSSWOOD_WALL}
          text={getWallTypeTranslations(t, WallTypeTypes.CROSSWOOD_WALL)}
          onClick={() => setWallTypeType(WallTypeTypes.CROSSWOOD_WALL)}>
          <CrossWoodIcon />
        </IconTile>
      </Grid>
    </Sidebar>
  );
};
